import { createBrowserHistory } from 'history';

const history = typeof window === 'undefined' ? {
  push: function push () {},
  replace: function replace () {},
  goBack: function goBack () {}
} : createBrowserHistory(); // eslint-disable-line

export default history;
